import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../commonService';

@Component({
  selector: 'app-canal-selector',
  templateUrl: './canal-selector.component.html',
  styleUrls: ['./canal-selector.component.scss']
})

export class CanalSelectorComponent implements OnInit {
  errorData: any;
  constructor(private routerparam: ActivatedRoute, private commonService: CommonService) { }
  ngOnInit(): void {

  }

  selectLanguage(language: string) {
    /*this.commonService.setLanguage(language);
    this.commonService.changeLanguage.next(language);
    this.commonService.hiddenLang.next(true);
    this.commonService.setFlag(language);
    if (language == 'pt-BR') {
      this.commonService.setFlag('br');
    }
    if (language == 'en') {
      this.commonService.setFlag('us');
    }
    this.commonService.changeFlag.next(true);*/
  }
}
